import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowLeftIcon, CopyIcon, CheckIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouReferralPage() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  const [copied, setCopied] = useState(false);
  const [referralLink, setReferralLink] = useState('');
  return <div className="min-h-screen w-full flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-990">
      <Navigation data-id="element-991" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-992">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-993">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-994">
            <UsersIcon className="w-12 h-12 text-white" data-id="element-995" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-996">
            Welcome to the Program!
          </h1>

          <p className="text-lg mb-4" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-997">
            Your referral application has been received.
          </p>

          <p className="text-base mb-8" style={{
          color: 'var(--text-muted)'
        }} data-id="element-998">
            We'll contact you within 24 hours with your unique referral link and
            all the details you need to start earning €100 per referral.
          </p>

          <div className="rounded-2xl border p-6 mb-8 text-left" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} data-id="element-999">
            <h3 className="font-semibold mb-3" style={{
            color: 'var(--text-primary)'
          }} data-id="element-1000">
              What happens next?
            </h3>
            <ul className="space-y-2 text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-1001">
              <li className="flex items-start gap-2" data-id="element-1002">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-1003">
                  1.
                </span>
                We'll review your application
              </li>
              <li className="flex items-start gap-2" data-id="element-1004">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-1005">
                  2.
                </span>
                You'll receive your unique referral link
              </li>
              <li className="flex items-start gap-2" data-id="element-1006">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-1007">
                  3.
                </span>
                Share the link and earn €100 for each successful referral
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1008">
            <a href={getPath('')} onClick={e => {
            e.preventDefault();
            navigate('');
          }} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)'
          }} data-id="element-1009">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-1010" />
              {t('nav.home')}
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-1011" />
    </div>;
}